<template>
  <!-- 绑定动态样式，通过transform控制头部位移 -->
  <header class="J-common-header" ref="headerBox" :style="{ transform: `translateY(${headerTranslateY}rem)` }"
    :class="lastScrollTop == 0 && isHomePage ? '' : 'active'">
    <a href="/">
      <img class="log" data-src="/assets/logo.png" alt="">
    </a>
    <nav>
      <div class="navs">
        <a class="nav-box" href="/about.html">
          <div class="nav-text">
            {{ currentLang === 'CN' ? '关于蜂巢' : 'ABOUT' }}
          </div>
        </a>
        <div class="nav-box nav-product-m" @click="handleOpenProduct()">
          <div class="nav-text">
            {{ currentLang === 'CN' ? '产品信息' : 'PRODUCT' }}

            <img class="nav-product-icon" src="/assets/common/nav-down.png" alt="" />
          </div>
          <div class="product-boxs">
            <div class="product-lists">
              <a href="/engine.html" class="product-item">
                <div class="product-title">
                  {{ currentLang === 'CN' ? '动力系统' : 'ENGINE SYSTEM' }}
                </div>
                <div class="product-img img-box">
                  <img data-src="/assets/common/nav-product1.jpg" alt="">
                </div>
              </a>

              <a href="/transmission.html" class="product-item">
                <div class="product-title">
                  {{ currentLang === 'CN' ? '传动系统' : 'TRANSMISSION SYSTEM' }}
                </div>
                <div class="product-img img-box">
                  <img data-src="/assets/common/nav-product2.jpg" alt="">
                </div>
              </a>

              <a href="/electronics.html" class="product-item">
                <div class="product-title">
                  {{ currentLang === 'CN' ? '电子系统' : 'ELECTRONICS SYSTEM' }}
                </div>
                <div class="product-img img-box">
                  <img data-src="/assets/common/nav-product3.jpg" alt="">
                </div>
              </a>
            </div>
          </div>
        </div>
        <a href="/manufacture.html" class="nav-box">
          <div class="nav-text">
            {{ currentLang === 'CN' ? '智能制造' : 'INTELLIGENT MANUFACTURING' }}
          </div>
        </a>
        <a href="/news.html" class="nav-box">
          <div class="nav-text">
            {{ currentLang === 'CN' ? '新闻资讯' : 'NEWS' }}
          </div>
        </a>
        <div class="nav-box nav-contact-us-m" @click="handleOpenContactUs()">
          <div class="nav-text">
            {{ currentLang === 'CN' ? '联系我们' : 'CONTACT US' }}
            <img class="nav-product-icon" src="/assets/common/nav-down.png" alt="" />
          </div>
          <div class="product-boxs contact-us-nav">
            <div class="product-lists">
              <a href="/contact-us.html" class="product-item">
                <div class="product-title">
                  {{ currentLang === 'CN' ? '商务合作' : 'BUSINESS COOPERATION' }}
                </div>
                <div class="product-img img-box">
                  <img data-src="/assets/common/contact.jpg" alt="">
                </div>
              </a>

              <a href="/join-us.html" class="product-item">
                <div class="product-title">
                  {{ currentLang === 'CN' ? '加入我们' : 'JOIN US' }}
                </div>
                <div class="product-img img-box">
                  <img data-src="/assets/common/join.jpg" alt="">
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="lang-switch">
        <div class="lang-icon">
          <img class="lang-e" data-src="/assets/common/eartch.png" alt=""></img>
          <img class="lang-h" data-src="/assets/common/eartch-h.png" alt=""></img>
        </div>
        <div class="lang-text" @click="handleSwitchLang()">{{ currentLang == "CN" ? "EN" : "CN" }}</div>
      </div>
    </nav>
    <div class="nav-open-btn" @click="handleOpenNav()">
      <img class="nav-open-icon" src="/assets/common/nav-open.png" alt=""></img>
      <img class="nav-close-icon" src="/assets/common/nav-close.png" alt=""></img>
    </div>

  </header>


</template>

<script setup>
import { computed, ref, onMounted, onUnmounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import $ from 'jquery';
const store = useStore();
const currentLang = computed(() => store.getters.currentLang);
const headerTranslateY = ref(0);
const lastScrollTop = ref(0);

const isHomePage = ref(true);

const isPc = ref(window.innerWidth > 768);

// 语言切换方法
const handleSwitchLang = () => {
  const pureUrl = window.location.origin + window.location.pathname;
  const currentPath = window.location.pathname;
  if (window.location.pathname === '/en/privacy.html' || window.location.pathname === '/privacy.html') {
    store.dispatch('switchLang', 'EN');
    location.href = '/en/';
  } else if (/^\/en\/news-detail/.test(currentPath)) {
    store.dispatch('switchLang', 'CN');
    location.href = '/news.html';
  } else if (/^\/news-detail/.test(currentPath)) {
    store.dispatch('switchLang', 'EN');
    location.href = '/en/news.html';
  } else {
    window.history.pushState({}, document.title, pureUrl);
    if (currentLang.value === 'CN') {
      currentLang.value = 'EN';
      store.dispatch('switchLang', 'EN');
    } else {
      currentLang.value = 'CN';
      store.dispatch('switchLang', 'CN');
    }
  }

};
const handleScroll = () => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop.value && scrollTop > 10) {
    headerTranslateY.value = -1.19;
  }
  else if (scrollTop < lastScrollTop.value) {
    headerTranslateY.value = 0;
  }
  lastScrollTop.value = scrollTop;
};
const GetQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}


// 移动端导航打开
const handleOpenNav = () => {
  const navs = document.querySelector('nav');
  const navOpenBtn = document.querySelector('.nav-open-btn');
  navs.classList.toggle('active');
  navOpenBtn.classList.toggle('active');
  $('#app').css('overflow-y', navs.classList.contains('active') ? 'hidden' : 'auto');
  $('#app').css('height', navs.classList.contains('active') ? '100vh' : 'auto');

};
// 移动端产品信息打开
const handleOpenProduct = (e) => {
  if (!isPc.value) {
    const navProduct = document.querySelector('.nav-product-m');
    navProduct.classList.toggle('active');
  }
};
// 移动端产品信息打开
const handleOpenContactUs = (e) => {
  if (!isPc.value) {
    const navContactUs = document.querySelector('.nav-contact-us-m');
    navContactUs.classList.toggle('active');
  }
};

const isCookie = ref(store.getters.isCookie);

// cookie同意
const handleCookiesAgree = () => {
  store.dispatch('setCookie', 1);
  isCookie.value = true;
};
// cookie不同意
const handleCookiesNo = () => {
  isCookie.value = true;
};
$('.nav-cookies-no').on('click', () => {
  handleCookiesNo();
  $('.nav-cookies').hide();
});
$('.nav-cookies-agree').on('click', () => {
  handleCookiesAgree();
  $('.nav-cookies').hide();
});



onMounted(() => {

  window.addEventListener('scroll', handleScroll);


  if (window.location.pathname === '/' || window.location.pathname == '/en/index.html') {
    isHomePage.value = true;
  } else {
    isHomePage.value = false;
  }

  store.dispatch('checkLangAndRedirect');

  document.addEventListener('click', (e) => {
    const aTag = e.target.closest('a');
    if (aTag && !e.target.closest('.lang-switch')) {
      e.preventDefault();
      const originalHref = aTag.getAttribute('href');
      const hasEnPath = /^\/en(\/|$)/.test(window.location.pathname);
      let pathLang = hasEnPath ? 'EN' : 'CN';

      const isBlankTarget = aTag.getAttribute('target') === '_blank';
      if (isBlankTarget) {
        window.open(originalHref);
        if (pathLang != localStorage.getItem('app-lang')) {
          store.dispatch('switchLang', pathLang);
        }
      } else {
        if (pathLang != localStorage.getItem('app-lang')) {
          store.dispatch('switchLang', pathLang);
        }
        window.location.href = originalHref;
      }
    }
  }, true);
  setTimeout(() => {
    $('.longing').hide();
  }, 1000);

  setTimeout(() => {
    if (!isCookie.value && currentLang.value === 'CN') {
      $('.nav-cookies').show();
    } else {
      $('.nav-cookies').hide();
    }
  }, 1700);

  nextTick(() => {
    const lazyVideos = document.querySelectorAll('video[data-src]');

    // 简单设备判断，你可按需替换更精准判断
    const isMobile = window.innerWidth <= 768;

    const videoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const video = entry.target;
          const hasPcPad = video.classList.contains('pc-pad');
          const hasMbOnly = video.classList.contains('mb-only');

          // 规则校验，不满足设备匹配直接跳过加载
          let canLoad = true;
          if (hasPcPad && isMobile) {
            canLoad = false;
          } else if (hasMbOnly && !isMobile) {
            canLoad = false;
          }
          if (!canLoad) {
            observer.unobserve(video);
            return;
          }

          // 正常懒加载原有逻辑
          if (!video.dataset.loaded && video.dataset.src) {
            video.dataset.loaded = 'loading';
            video.src = video.dataset.src;

            const handleLoaded = function () {
              video.dataset.loaded = 'true';
              video.removeEventListener('loadeddata', handleLoaded);
            };
            video.addEventListener('loadeddata', handleLoaded);
          }
          observer.unobserve(video);
        }
      });
    });

    lazyVideos.forEach(video => {
      if (video.dataset.src) {
        videoObserver.observe(video);
      }
    });
    // 图片懒加载
    const lazyImages = document.querySelectorAll("img[data-src]");
    let isProcessing = false; // 用于防抖的标记
    // 在checkImages函数中，设置默认src作为占位符
    function checkImages() {
      if (isProcessing) return;
      isProcessing = true;
      requestAnimationFrame(() => {
        lazyImages.forEach(img => {
          if (!img.dataset.src) return;
          const rect = img.getBoundingClientRect();
          const windowHeight = window.innerHeight || document.documentElement.clientHeight;

          // 在图片加载前设置默认样式
          if (!img.dataset.loaded) {
            img.dataset.loaded = 'false';
          }

          if (rect.top <= windowHeight + 200) {
            img.src = img.dataset.src;
            // img.removeAttribute("data-src");
            img.dataset.loaded = 'true';

          }
        });
        isProcessing = false;
      });
    }

    checkImages();
    window.addEventListener("scroll", checkImages);
    window.addEventListener("resize", checkImages);
  });

});
onUnmounted(() => {
  // if (isPc.value) {
  //   window.removeEventListener('scroll', handleScroll);
  // }
  window.removeEventListener('scroll', handleScroll);
});
</script>

<script>
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept('./Navbar.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss">
.J-common-header {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vw - 3.16rem);
  height: 0.9rem;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.56rem;
  cursor: pointer;
  transition: transform 0.6s ease-in-out;

  .log {
    height: 0.38rem;
    width: auto;
    object-fit: cover;
  }

  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.19rem;
    height: 100%;

    .navs {
      display: flex;
      height: 100%;
      gap: 0.57rem;

      .nav-box {
        display: flex;
        align-items: center;
        justify-content: center;
        // position: relative;
        height: 100%;
        height: 100%;

        .nav-text {
          font-size: 0.18rem;
          color: #fff;
          font-weight: 400;
          position: relative;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          &::after {
            content: '';
            position: absolute;
            width: 0;
            height: 0.02rem;
            background: #E70012;
            left: 0;
            bottom: 0;
            transition: all 0.3s;
          }

          &:hover {
            color: #000;

            &::after {
              width: 100%;
            }
          }

          .nav-product-icon {
            display: none;
          }

        }

        .product-boxs {
          position: absolute;
          top: 0.9rem;
          left: 0;
          width: 100vw;
          height: auto;
          background: #ffffff;
          z-index: 999;
          display: none;

          .product-lists {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            align-items: center;
            gap: 0.5rem;
            padding-top: 0.31rem;
            padding-bottom: 0.6rem;

            .product-item {
              cursor: pointer;
              width: 3.52rem;
              height: 2.16rem;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0.17) 0%, #F6F8FA 100%);
              border-radius: 10px 10px 10px 10px;
              overflow: hidden;
              position: relative;


              .product-title {
                font-size: 0.2rem;
                color: #000;
                margin: 0.23rem 0.25rem 0;
                position: relative;
                z-index: 1;
              }

              .product-img {
                width: 100%;
                display: flex;
                justify-content: center;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 0;

                img {
                  transition: all 0.3s;
                }
              }

              &:hover {
                .product-img {
                  img {
                    transform: scale(1.1);
                  }
                }
              }
            }
          }
        }

        .contact-us-nav {
          .product-lists {
            .product-item {
              .product-title {
                color: #fff;
              }
            }
          }
        }

        &:hover {
          &::after {
            width: 100%;
          }

          .product-boxs {
            display: block;
          }
        }
      }
    }

    .lang-switch {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.09rem;

      .lang-icon {
        position: relative;
        width: 0.16rem;
        height: 0.16rem;

        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .lang-e {
          display: block;
        }

        .lang-h {
          display: none;
        }
      }

      .lang-text {
        font-weight: 400;
        font-size: 0.15rem;
        color: #FFFFFF;
      }
    }
  }

  &:hover,
  &.active {
    background: #fff;

    nav {
      .navs {
        .nav-text {
          color: #000;
        }
      }
    }

    .lang-switch {
      .lang-icon {
        .lang-e {
          display: none;
        }

        .lang-h {
          display: block;
        }
      }

      .lang-text {
        color: #000;
      }
    }
  }

  .nav-open-btn {
    display: none;
  }
}


@keyframes fadeOut {
  0% {
    top: -60px;
  }

  100% {
    top: 30px;
  }
}

@media screen and (max-width: 768px) {
  .J-common-header {
    width: calc(100vw - 0.64rem);
    padding: 0 0.32rem;
    background: #fff;
    -webkit-tap-highlight-color: transparent;

    &:hover,
    &.active {
      background: #fff;
    }

    nav {
      display: none;

      &.active {
        display: flex;
        position: fixed;
        top: 0.9rem;
        left: 0;
        width: calc(100vw - 0.9rem);
        height: calc(100vh - 0.9rem);
        background: #fff;
        flex-direction: column;
        padding: 0.45rem;
        justify-content: flex-start;
        gap: 0.5rem;

        .navs {
          flex-direction: column;
          width: 100%;
          gap: 0;
          height: auto;
          display: block;

          .nav-box {
            padding: 0.42rem 0;
            border-bottom: 0.01rem solid #EBEBEB;
            justify-content: flex-start;
            height: 0.3rem;
            overflow: hidden;

            .nav-text {
              font-size: 0.3rem;
              font-weight: 400;

              &:hover {
                &::after {
                  width: 0;
                }
              }

            }

            &:hover {
              &::after {
                width: 0;
              }
            }
          }

          .nav-product-m,
          .nav-contact-us-m {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .product-boxs {
              position: unset;
              margin-top: 0.42rem;
              width: 100%;

              .product-lists {
                gap: 0.24rem;
                justify-content: flex-start;
                width: 100%;

                .product-item {
                  width: calc(50% - 0.12rem);

                  &:hover {
                    .product-img {
                      img {
                        transform: scale(1);
                      }
                    }
                  }
                }
              }
            }

            .nav-text {
              width: 100%;
              justify-content: space-between;

              .nav-product-icon {
                display: block;
                width: 0.3rem;
                height: auto;
                object-fit: cover;
                transition: all 0.3s ease-in-out;
              }
            }

            &.active {
              height: auto;
              overflow: hidden;

              .nav-text {
                .nav-product-icon {
                  transform: rotate(180deg);
                }
              }
            }

          }
        }
      }

      .lang-switch {
        .lang-text {
          font-size: 0.26rem;
          font-weight: 400;
        }

        .lang-icon {
          display: none;
        }
      }
    }

    .nav-open-btn {
      display: block;
      width: 0.38rem;
      height: 0.38rem;
      position: relative;
      cursor: pointer;
      // background: #fff;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
        object-position: center;

      }

      .nav-open-icon {
        display: block;
      }

      .nav-close-icon {
        display: none;
      }

      &.active {
        .nav-open-icon {
          display: none;
        }

        .nav-close-icon {
          display: block;
        }
      }
    }
  }


}
</style>